


  export default {
    props: {
      region: {
        type: String,
        default: 'uk'
      }
    },
    data() {
      return {
        ready:false

      }
    },
    head() {
    if(this.ready){
    return {
            script: [{ type: 'application/ld+json', json: this.structuredData }]
        }
      }
    },
    computed: {
      // MAYBE JUST NEED UK/US FOR BOTS
      phoneNumber() {
        let region = '+1 888.897.2570'
        let path
        switch(true) {
          case this.$props.region === 'uk':
          region = '0330 808 9138';
          path = ''
          break;
          case this.$props.region === 'US':
          region = '888.897.2570';
          path = 'en-us'
          break;
          case this.$props.region === 'AU':
          region = '+1 888.897.2570';
          path = 'au'
          break;
          case this.$props.region === 'ZA':
          region = '+1 888.897.2570';
          path= 'za'
          break;
          case this.$props.region === 'CA':
          region = '+1 888.897.2570';
          path = 'ca'
          break;
          case this.$props.region === 'IE':
          region = '+353 1 270 7964';
          path = 'ie'

          break;
        }
        return {region, path}
      },
      structuredData() {
        if(this.$props.region === 'uk') {
        return {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "The TEFL Org",
          "url": "https://www.tefl.org/",
          "logo": "https://www.tefl.org/_nuxt/images/tefl-org-web_strapline-ee5f8b.svg",
          "sameAs": [ "https://www.facebook.com/teflorg", "https://x.com/TEFLOrg", "https://www.instagram.com/teflorg/" , "https://www.linkedin.com/company/teflorg/" ],
          "description": "Internationally accredited and market leading TEFL course provider. Earn your TEFL (Teaching English as a Foreign Language) certification and start teaching English abroad or online with The TEFL Org",
          "email": "info@tefl.org",
          "telephone": this.phoneNumber.region,
        }
      } else {
        return {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "The TEFL Org",
          "url": `https://www.tefl.org/${this.phoneNumber.path}/`,
          "logo": "https://www.tefl.org/_nuxt/images/tefl-org-web_strapline-ee5f8b.svg",
          "sameAs": [ "https://www.facebook.com/teflorg", "https://x.com/TEFLOrg", "https://www.instagram.com/teflorg/" , "https://www.linkedin.com/company/teflorg/" ],
          "description": "Internationally accredited and market leading TEFL course provider. Earn your TEFL (Teaching English as a Foreign Language) certification and start teaching English abroad or online with The TEFL Org",
          "email": "info@tefl.org",
          "telephone": this.phoneNumber.region,
        }
      }
      }
    },
    mounted() {
      this.ready = true
    }
  }

// CODE IF USING DETECED REGION INSTEAD OF REGION PROP
  //  computed: {
  //   ...mapGetters({
  //     detectedRegion: 'geolocation/region',
  //     userRegion: 'user/region',
  //   }),
  //   normalizedRegion() {
  //     const regionCode = this.userRegion && this.userRegion !== 'default'
  //                      ? this.userRegion
  //                      : this.detectedRegion;
  //     return regionCode;
  //   },
  //     // add ofqual for uk can pass a prop maybe
  //     phoneNumber() {
  //       let number = '+1 888.897.2570'
  //       let path
  //       switch(true) {
  //         case this.normalizedRegion === 'en':
  //         number = '0330 808 9138';
  //         path = ''
  //         break;
  //         case this.normalizedRegion === 'en-us':
  //         number = '888.897.2570';
  //         path = 'en-us/'
  //         break;
  //         case this.normalizedRegion === 'au':
  //         number = '+1 888.897.2570';
  //         path = 'au/'
  //         break;
  //         case this.normalizedRegion === 'za':
  //         number = '+1 888.897.2570';
  //         path= 'za/'
  //         break;
  //         case this.normalizedRegion === 'ca':
  //         number = '+1 888.897.2570';
  //         path = 'ca/'
  //         break;
  //         case this.normalizedRegion === 'ie':
  //         number = '+353 1 270 7964';
  //         path = 'ie/'
  //         break;
  //         case this.normalizedRegion === 'eu':
  //         number = '+353 1 270 7964';
  //         path = ''
  //         break;
  //         case this.normalizedRegion === 'row':
  //         number = '+1 888.897.2570';
  //         path = ''
  //         break;
  //       }
  //       return {number, path}
  //     },
  //     structuredData() {
  //       return {
  //         "@context": "https://schema.org",
  //         "@type": "Organization",
  //         "name": "The TEFL Org",
  //         "url": `https://www.tefl.org/${this.phoneNumber.path}`,
  //         "logo": "https://www.tefl.org/_nuxt/images/tefl-org-web_strapline-ee5f8b.svg",
  //         "sameAs": [ "https://www.facebook.com/teflorg", "https://x.com/TEFLOrg", "https://www.instagram.com/teflorg/" , "https://www.linkedin.com/company/teflorg/" ],
  //         "description": "Internationally accredited and market leading TEFL course provider. Earn your TEFL (Teaching English as a Foreign Language) certification and start teaching English abroad or online with The TEFL Org",
  //         "email": "info@tefl.org",
  //         "telephone": this.phoneNumber.number,
  //         }
  //     }
  //   },
